module.exports = __webpack_public_path__ + "img/top_image1.fdad25a9.png";